import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Navbar, Footer } from 'components/layouts';
import theme from 'utils/theme';

const Page = ({ children }) => {
  window.scrollTo(0, 0);

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Navbar />
        <Content>{children}</Content>
        <Footer />
      </div>
    </ThemeProvider>
  );
};

export default Page;

const Content = styled.div`
  margin-bottom: 50px;
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/components/layouts/page/page.js